import { render } from "./QuestionModalEditor.vue?vue&type=template&id=1018c9f4&scoped=true"
import script from "./QuestionModalEditor.vue?vue&type=script&lang=js"
export * from "./QuestionModalEditor.vue?vue&type=script&lang=js"

import "./QuestionModalEditor.vue?vue&type=style&index=0&id=1018c9f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1018c9f4"],['__file',"src/components/admin/QuestionModalEditor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1018c9f4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1018c9f4', __exports__)) {
    api.reload('1018c9f4', __exports__)
  }
  
  module.hot.accept("./QuestionModalEditor.vue?vue&type=template&id=1018c9f4&scoped=true", () => {
    api.rerender('1018c9f4', render)
  })

}


export default __exports__